import * as React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { Box } from "@mui/material";

export default function Footer() {
  return (
    <Box
      sx={{
        backgroundColor: (theme) =>
          theme.palette.mode === "light"
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
        p: 6,
      }}
      component="footer"
    >
      <Container maxWidth="sm">
        <Typography variant="body2" color="text.secondary" align="center">
          DIT Research Finder {new Date().getFullYear()}
          {". "}
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{ marginTop: "1vh" }}
        >
          {"Copyright © "}
        </Typography>

        <Typography variant="body2" color="text.secondary" align="center">
          <Link
            color="inherit"
            target="_blank"
            href="https://www.linkedin.com/in/upeksha-samarasinghe"
          >
            Upeksha Samarasinghe
          </Link>
        </Typography>

        {/* <Typography variant="body2" color="text.secondary" align="center">
          <Link
            color="inherit"
            target="_blank"
            href="https://www.linkedin.com/in/thisura-em"
          >
            {" "}
            Thisura Embuldeniya
          </Link>{" "}
        </Typography> */}

        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
        ></Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{ marginTop: "1vh" }}
        >
          {" "}
          Source : Google Scholar Profiles of each Academic
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{ marginTop: "1vh" }}
        >
          {" "}
          License to : Department of Information Technology, FMSC, USJ
        </Typography>
      </Container>
    </Box>
  );
}
